<template>
    <div class="ksBox">
        <div class="searchItem flex fle-item flex-just">
            <div class="item">
                <el-input
                        class="mr10"
                        placeholder="名称 搜索"
                        v-model="gsinput"
                        clearable>
                </el-input>
                <el-select class="mr10" v-model="state" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="searchData">检索</el-button>
            </div>
            <div class="item-right flex">
                <div class="uploadFile">
                    <el-button type="info" class="uploadBtn">上传文件</el-button>
                    <input  type="file" name="files" value="" id="uploadfile2" multiple="multiple" accept=".xls"
                            class="upload-input uploadfile1" @change="importFile">
                </div>
                <div class="xz">
                    <el-button type="primary">新增</el-button>
                </div>
            </div>

        </div>
        <!--      表格-->
        <div class="dataTable mt20">
            <template>
                <el-table
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            prop="i_fid"
                            align="center"
                            label="编码"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="vc_name"
                            align="center"
                            label="名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <!--<el-table-column
                            prop="vc_creditcode"
                            align="center"
                            label="信用代码"
                            show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column
                            prop="vc_app"
                            align="center"
                            label="订阅系统"
                            width="120"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_state"
                            align="center"
                            label="状态"
                            width="120"
                            :formatter="State"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="dt_importtime"
                            align="center"
                            label="时间"
                            show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column
                            align="center"
                            label="操作"
                            width="160">
                        <template slot-scope="scope">
                            <!--                                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>-->
                            <el-button type="text" size="small" style="color: #67C23A" v-if="scope.row.vc_state=='003'" @click="editData(scope.row)">编辑  |</el-button>
                            <el-button type="text" size="small">发布 | </el-button>
                            <el-button type="text" size="small" style="color: #F56C6C">归档</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tableBottom flex fle-item flex-just mt20">
                    <div class="tbLeft">
                        <el-button type="primary">批量发布</el-button>
                        <el-button type="primary">批量归档</el-button>
                    </div>
                    <div class="tbRight">
                        <div class="paginationBox textRig" >
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    @current-change="pageCurrentChange"
                                    :current-page.sync="currentPage"
                                    :total="tableTotal">
                            </el-pagination>
                        </div>
                    </div>
                </div>

            </template>
        </div>
        <el-dialog title="数据编辑" :model="GetData" ref="GetData" :visible.sync="dialogFormVisibleData" v-if="dialogFormVisibleData" @close="cancelData" :close-on-click-modal="false" width="1150px" height="500px">
            <el-row>
                <el-col :span="12">
                    <div class="grid-content ">
                        <h3> 业务数据 ({{GetData.vc_app}})</h3>
                        <div>
                            <span class="dataSpan" >编码:</span>
                            <span >{{GetData.i_fid}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">名称:</span>
                            <span :class="zColor">{{GetData.vc_name}}</span>
                        </div>
                        <!--<div>
                            <span class="dataSpan">信用代码:</span>
                            <span :class="cColor" >{{GetData.vc_creditcode}}</span>
                        </div>-->


                    </div>
                </el-col>
                <el-col :span="12" v-for="(data,i) in abnormalData">
                    <div class="grid-content " >
                        <h3 > 主数据</h3>
                        <div>
                            <span class="dataSpan" >编码:</span>
                            <span >{{data.i_fid}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">名称:</span>
                            <span :class="zColor">{{data.vc_name}}</span>
                        </div>
                        <!--<div>
                            <span class="dataSpan">信用代码:</span>
                            <span >{{data.vc_creditcode}}</span>
                        </div>-->

                    </div>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer" 　style="text-align: center;">
                <el-button type="primary" @click="handleData" v-bind:disabled="isHandle">更新主数据</el-button>
                <el-button type="primary" @click="tipsRelation" v-bind:disabled="isRelation">创建关系</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from  "./api";
    import {filerequest_url} from './api';
    import {mapActions} from "vuex";
    export default {
        name: "index",
        data(){
            return{
                isRelation:false,
                isHandle:false,
                state:"003",
                options: [{
                    value: '002',
                    label: '已处理'
                }, {
                    value: '003',
                    label: '异常'
                }],
                GetData:{
                    i_fid:"",
                    vc_app:"",
                    vc_name:"",
                    // vc_creditcode:"",
                },
                dialogFormVisibleData:false,
                gsinput:"",
                fileName:"",
                fileType:"",
                fileUrl:"",
                value:"",
                i_uid:"",
                tableData: [],
                tableTotal:0,
                pageSize:1,
                currentPage:1,
                abnormalData:[],
                i_id:"",
                qi_id:"",
                qvc_user:"",
                qvc_creditcode:"",
                qvc_name:"",
                qi_fid:"",
                yi_id:"",
                qvc_app:"",
                zColor:"backColor",
                cColor:"backColor",
            }
        },
        mounted() {
            this.getMDataMessage();
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            async getMDataMessage(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:this.gsinput,
                    vc_state:this.state,
                    i_type: 6,
                    tableData: [],
                };
                let res=await API.getMDataMessage(param);
                if(res.code==1){
                    //console.log("res",res);
                    this.tableData= res.data;
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
            async searchPZdata(){
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:this.gsinput,
                    vc_state:this.state,
                    i_type: 6,
                    tableData: [],
                };
                let res=await API.getMDataMessage(param);
                if(res.code==1){
                    //console.log("res",res);
                    this.tableData= res.data;
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },


            async importFile(value){
                // console.log(value.target.files);
                let _this=this;
                let $files=value.target.files[0];
                let fileName=$files.name;
                var type = fileName.substring(fileName.lastIndexOf('.') + 1);
                const extension = type === 'xls' ;
                if ($files && extension==false) {
                    this.$message.error('请上传格式正确的文件');
                    return;
                };
                if($files){
                    _this.fileName=$files.name;
                    //_this.fileUrl=window.URL.createObjectURL(value.target.files[0]);
                    // console.log("$files",$files)
                }else{
                    _this.fileName="";
                    //_this.fileUrl="";
                }
                if(_this.fileName) {
                    document.getElementById('uploadfile2').value = null;
                    let param = {
                        "myFile": $files,
                        "token": sessionStorage.getItem("token"),
                        "i_uid": sessionStorage.getItem("userid"),
                        "app":"masterdata",
                        "version":"1.0",
                        "myFileFileName": _this.fileName,
                        "i_type": 6,
                    };
                    // console.log($files,"$files");
                    let FD = new FormData();
                    // FD.file=$files;

                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await  fetch(filerequest_url, {
                        method:"post",
                        body:FD
                    }).then(res=>res.text());
                    res =JSON.parse(res);
//                    console.log(res.code,"res");
                    if(res.code == 1){
                        _this.$message({
                            type:'success',
                            message:'导入成功'
                        })
                    }else{
                        _this.$message({
                            type:'error',
                            message:res.message
                        })
                    }

                }
            },
            async editData(value){
//                console.log("value",value);
                this.isHandle=false;
                this.isRelation=false;
                this.qi_id=value.i_id;
                this.qi_fid=value.i_fid;
                this.qvc_app=value.vc_app;
                this.qvc_user=value.vc_user;
                //this.qvc_creditcode=value.vc_creditcode;
                this.qvc_name=value.vc_name;
                this.GetData.i_fid=value.i_fid;
                this.GetData.vc_name=value.vc_name;
                //this.GetData.vc_creditcode=value.vc_creditcode;
                this.GetData.vc_app=value.vc_app;
                this.dialogFormVisibleData=true;
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    vc_name:value.vc_name,
                    i_type: 6,
                    //vc_creditcode:value.vc_creditcode,

                };
                let res=await API.getEditMessage(param);
                if(res.code==1){

                    this.abnormalData=res.data;
                    this.yi_id=res.data[0].i_id;
                    //this.vc_creditcode=res.data[0].vc_creditcode;
                    this.vc_name=res.data[0].vc_name;
                    /*if(this.qvc_creditcode!=this.vc_creditcode){
                        this.cColor="redColor";
                    }*/
                    if(this.qvc_name!=this.vc_name){
                        this.zColor="redColor";
                    }
                    // console.log("qvc_creditcode",this.qvc_creditcode,this.vc_creditcode);
                    // console.log("qvc_name",this.qvc_name,this.vc_name);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            async handleData(){
                this.isHandle=true;
                let param={
                    i_id:this.yi_id,
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    vc_name:this.qvc_name,
                    i_type: 6,
                    //vc_creditcode:this.qvc_creditcode,
                    vc_code:this.qi_fid,
                };
                let res=await API.replaceMasterData(param);
                if(res.code==1){
                    //_this.isHandle=false;
                    this.$message.success(res.message);
                    //this.vc_creditcode=this.qvc_creditcode;
                    this.vc_name=this.qvc_name;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },

            tipsRelation(){

                if(this.qvc_name!=this.vc_name){
                    this.$confirm('存在不相同数据确定要创建关系?','提示',{
                        confirmButtonText:'确定',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(()=>{
                        this.isRelation=true;
                        this.relationship();
                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消'
                        })
                    })
                }else {
                    this.isRelation=true;
                    this.relationship();
                }
            },
            async relationship(){
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    vc_name:this.vc_name,
                    i_type: 6,
                    //vc_creditcode:this.vc_creditcode,
                    i_sysid:this.yi_id,
                    i_appid:this.qi_id,
                    vc_app:this.qvc_app,
                    i_fid:this.qi_fid,
                    vc_user:this.qvc_user,
                };
                let res=await API.saveMDRelation(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.getMDataMessage();
                    this.dialogFormVisibleData=false;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            cancelData(){
                this.dialogFormVisibleData=false;
                this.cColor="backColor";
                this.zColor="backColor";

            },

            State(row, column, cellValue, index){
                if(row.vc_state==='002'){
                    return '已处理'
                }else if(row.vc_state==='003'){
                    return '异常'
                }
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
                this.getMDataMessage();
            },
            searchData(){
                this.pageSize=1;
                this.currentPage=1;
                this.searchPZdata();
            },
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                // console.log(val)
            }
        },
    }
</script>

<style lang="scss"  scoped>
    .flex{
        display: flex;
    }
    .fle-item{
        align-items: center;
    }
    .flex-just{
        justify-content: space-between;
    }
    .mr10{
        margin-right: 10px;
    }
    .mt20{
        margin-top: 20px;
    }
    .ksBox{
        height: 100%;
        margin-top: 20px;
    }
    .searchItem{
        .item{
            width: 30%;
            /deep/{


            }
        }
        .item-right{
            margin-right: 40px;
            .xz{
                margin-left: 10px;
            }
        }
    }
    .uploadFile{
        /*height: 80px;*/
        overflow: hidden;
        position: relative;
        .uploadBtn{
            width: 150px;
        }
        .upload-input{
            width: 150px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }
    }
    .dataSpan{
        width: 100px;
        display: inline-block;
        padding-top: 10px;
    }
    .backColor{
        color: #606266;
    }
    .redColor{
        color: red;
    }
    /deep/{
        .el-dialog{
            font-size: 20px;
        }
        .el-dialog__header{
            background-color: #3e82e8;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
    }
</style>